import React, { PureComponent } from "react";
import t from "@zendesk/client-i18n-tools";
import { createVerificationRuleMutation } from "mutations/verificationRuleMutations";
import { Button } from "@zendeskgarden/react-buttons";
import { Query } from "react-apollo";
import { showIndex } from "utils/navigation";
import { notifications } from "@zendesk/knowledge-components/lib/Notifications/Connected";
import prepareFilters from "utils/prepareFilters";
import MutationWithOverlay from "components/MutationWithOverlay";
import gql from "graphql-tag";

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      ruleName
      frequency
      filters {
        type
        value
      }
      notificationRecipient
    }
  }
`;

export default class CreateVerificationRuleMutation extends PureComponent {
  onCreated = ({ createVerificationRule: { success } }) => {
    if (success) {
      showIndex({ skipDirtyCheck: true });
      notifications.showSuccess({
        title: t(
          "knowledge-verification.notification.verificationRuleCreate.title"
        ),
        message: t(
          "knowledge-verification.notification.verificationRuleCreate.message"
        ),
      });
    } else {
      notifications.showError({
        message: t(
          "knowledge-verification.notification.verificationRuleCreate.failed"
        ),
      });
    }
  };

  render() {
    return (
      <Query query={dirtyStateQuery}>
        {({ data: { dirtyState } }) => (
          <MutationWithOverlay
            mutation={createVerificationRuleMutation}
            refetchQueries={["verificationRules"]}
            variables={{
              name: dirtyState.ruleName,
              filter: prepareFilters(dirtyState.filters),
              frequency: dirtyState.frequency,
              notification: {
                recipient: dirtyState.notificationRecipient,
              },
            }}
            awaitRefetchQueries
            onCompleted={this.onCreated}
          >
            {mutate => (
              <Button size="small" primary onClick={mutate}>
                {t("knowledge-verification.create")}
              </Button>
            )}
          </MutationWithOverlay>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CreateVerificationRuleMutation/index.js